import GrayCard from "components/gray-card";
import React from "react";
import styled from "styled-components";

interface IProps {
  file: File | undefined;
}
const VideoPreviewCard = ({ file }: IProps) => {
  return (
    <GrayCard title="Video Preview">
      <VideoContainer controls>
        {file && <source src={URL.createObjectURL(file)} type="video/mp4" />}
      </VideoContainer>
    </GrayCard>
  );
};

export default VideoPreviewCard;

const VideoContainer = styled.video`
  width: 100%;
  height: 35rem;
  @media only screen and (max-width: 769px) {
    height: 15rem;
  }
`;
